import { auth } from "@/services/firebase/config";
import { apiClient } from "./base.service";
import type { BillingStatusResponse } from "@/types/billing.types";

async function authHeaders(): Promise<Record<string, string>> {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Not authenticated");
  }

  const token = await user.getIdToken();
  return { Authorization: `Bearer ${token}` };
}

export const billingService = {
  async getStatus(): Promise<BillingStatusResponse> {
    const headers = await authHeaders();
    return apiClient.get<BillingStatusResponse>("/billing/status", { headers });
  },

  async createCheckoutSession(
    interval: "month" | "year",
  ): Promise<{ url: string }> {
    const headers = await authHeaders();
    return apiClient.post<{ url: string }>(
      "/billing/checkout-session",
      { interval },
      { headers },
    );
  },

  async createPortalSession(): Promise<{ url: string }> {
    const headers = await authHeaders();
    return apiClient.post<{ url: string }>(
      "/billing/portal-session",
      undefined,
      { headers },
    );
  },
};
